import { render } from "./RankingBrowserApp.vue?vue&type=template&id=27b00001"
import script from "./RankingBrowserApp.vue?vue&type=script&lang=js"
export * from "./RankingBrowserApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__